<script setup lang="ts">
import { useAppStore } from "@/stores/app";
import { useUserStore } from "@/stores/user";
import {
  IonList,
  IonHeader,
  IonToolbar,
  IonPage,
  IonTitle,
  IonToggle,
  IonLabel,
  IonItem,
  IonContent,
  IonIcon,
  IonFooter,
} from "@ionic/vue";
import {
  home,
  moon,
  add,
  settings,
  swapHorizontal,
  help,
  information,
  globe,
  personCircle,
  logOutOutline,
} from "ionicons/icons";
import { usePlansStore } from "@/stores/plans";

import { computed } from "vue";

const userStore = useUserStore();
const appStore = useAppStore();
const plansStore = usePlansStore();
const dark_mode = appStore.settings.theme === "dark";

const limit_events_reached = computed(() => userStore.related.events.length >= plansStore.currentPlan.check_in_max_events)

</script>

<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>Navigation</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="container">
        <!-- <h3>Your events</h3>
      <ion-chip>
        <ion-avatar>
          <img
            alt="Silhouette of a person's head"
            src="https://s3.eu-west-1.amazonaws.com/f.beamian.com/uploads/images/prime_it_logo_v2_e505fccf5e5e2af9dc7da350fd21c5d2.png"
          />
        </ion-avatar>
        <ion-label>Winter Wonderland</ion-label>
      </ion-chip>
      <ion-chip style="background: blue">
        <ion-avatar>
          <img
            alt="Silhouette of a person's head"
            src="https://s3.eu-west-1.amazonaws.com/f.beamian.com/uploads/images/logo-site_94bf387e5803e90a22aeb0c1948fcde5_3323642c02f16c9ccd5ee669389fb890.png"
          />
        </ion-avatar>
        <ion-label>ISEG Career Forum </ion-label>
      </ion-chip>
      <ion-chip>
        <ion-avatar style="background: #fff">
          <img
            alt="Silhouette of a person's head"
            src="https://s3.eu-west-1.amazonaws.com/f.beamian.com/uploads/images/ipca_preto_39d9260f09e7d8905381dd29d9e95335.png"
          />
        </ion-avatar>
        <ion-label>Grow Your Skills Up </ion-label>
      </ion-chip>
      <ion-button
        size="small"
        expand="block"
        class="ion-margin-top"
        color="light"
      >
        See all
      </ion-button>
      <hr /> -->
        <ion-list class="ion-margin-top">
          <ion-item href="/home">
            <ion-icon :icon="home" slot="start"></ion-icon>
            Home
          </ion-item>
          <ion-item href="/onboarding/new-event" v-if="!limit_events_reached">
            <ion-icon :icon="add" slot="start"></ion-icon>
            Create event
          </ion-item>
          <ion-item href="/manage-events">
            <ion-icon :icon="settings" slot="start"></ion-icon>
            Manage Events
          </ion-item>
          <ion-item v-if="userStore.userIsAdmin" href="/events">
            <ion-icon :icon="swapHorizontal" slot="start"></ion-icon>
            Change event
          </ion-item>

          <!-- <ion-item>
          <ion-icon :icon="person" slot="start"></ion-icon>
          <ion-menu-toggle>
            <router-link to="/my-account"> Manage organization </router-link>
          </ion-menu-toggle>
        </ion-item>
        <ion-item>
          <ion-icon :icon="logOut" slot="start"></ion-icon>

          <ion-menu-toggle>
            <router-link to="/login"> Change organization </router-link>
          </ion-menu-toggle>
        </ion-item> -->

          <ion-item>
            <ion-icon :icon="help" slot="start"></ion-icon>
            <a
              href="https://beamian-kb.atlassian.net/servicedesk/customer/portal/9"
              target="_blank"
            >
              Help center
            </a>
          </ion-item>
          <ion-item>
            <ion-icon :icon="information" slot="start"></ion-icon>
            <a href="https://info.beamian.com/about-beamian" target="_blank">
              About us
            </a>
          </ion-item>
          <ion-item>
            <ion-icon :icon="globe" slot="start"></ion-icon>
            <a
              href="https://info.beamian.com/need-more-than-check-in"
              target="_blank"
            >
              Need more than check-in?
            </a>
          </ion-item>
        </ion-list>
        <hr />
        <template v-if="userStore.me.email">
          <small>{{ userStore.me.email }}</small>

          <ion-list>
            <ion-item href="/my-account">
              <ion-icon :icon="personCircle" slot="start"></ion-icon>
              My profile
            </ion-item>
            <ion-item href="/login">
              <ion-icon :icon="logOutOutline" slot="start"></ion-icon>
              Log out
            </ion-item>
          </ion-list>
        </template>
      </div>
    </ion-content>

    <ion-footer>
      <ion-item style="--border-color: var(--ion-color-light)">
        <ion-icon :icon="moon" slot="start"></ion-icon>

        <ion-label>Dark mode</ion-label>

        <ion-toggle
          :checked="dark_mode"
          slot="end"
          @click="appStore.toggleTheme()"
        />
      </ion-item>
    </ion-footer>
  </ion-page>
</template>

<style lang="scss" scoped>
ion-list {
  --background: none;
  ion-item {
    --background: none;
    .item-native {
      --background: none;
    }
  }
}
</style>
